// Web billing adapter — purchases are not available on the web build.
// In non-production (preview/dev) it supports a clearly-labeled simulated
// purchase so entitlement flows can be exercised end-to-end before the
// Play Console is configured.

const SIM_KEY = "un_premium_sim_v1";

// Display-only fallback plans; real prices always come from the store on device.
const DISPLAY_PLANS = [];

const simulateAllowed = () => process.env.NODE_ENV !== "production";

export const createWebBilling = () => ({
  platform: "web",
  canPurchase: false,
  canSimulate: simulateAllowed(),

  async init() {},
  async identify() { return { ok: true, premium: false }; },
  async clearIdentity() { return { ok: true }; },

  async getPlans() {
    return DISPLAY_PLANS;
  },

  async isPremium() {
    if (simulateAllowed()) {
      try {
        return localStorage.getItem(SIM_KEY) === "1";
      } catch {
        return false;
      }
    }
    return false;
  },

  async purchase() {
    return {
      ok: false,
      code: "WEB_UNAVAILABLE",
      message: "Subscriptions are available in the Android app.",
    };
  },

  async simulatePurchase() {
    if (!simulateAllowed()) return { ok: false, code: "NOT_ALLOWED", message: "" };
    try {
      localStorage.setItem(SIM_KEY, "1");
    } catch (e) {
      console.warn("[billing] simulate:", e?.message || e);
    }
    return { ok: true, premium: true };
  },

  async simulateClear() {
    try {
      localStorage.removeItem(SIM_KEY);
    } catch (e) {
      console.warn("[billing] simulateClear:", e?.message || e);
    }
    return { ok: true, premium: false };
  },

  async restore() {
    return {
      ok: false,
      code: "WEB_UNAVAILABLE",
      message: "Restore is available in the Android app.",
    };
  },
});
